<template lang='pug'>
i.svg-icon.svg-icon-cure2
  svg(
    :fill='color'
    :width='`${size}px`'
    :height='`${size}px`'
    viewBox='0 0 100 100'
  )
    polygon(points='89.462,36.23 64.149,36.23 64.149,10.917 36.032,10.917 36.032,36.229 10.719,36.229 10.719,64.347 36.032,64.347 36.032,89.66 64.149,89.66 64.149,64.347 89.462,64.347 ')
    polygon(points='50.375,89.66 64.158,89.66 64.158,64.348 89.471,64.348 89.471,36.23 64.158,36.23 64.158,10.917 50.375,10.917 ')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
  },

}
</script>